import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface LabelValueOption {
  label: string
  value: string
}

function useReviewLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const HOTEL_DESCRIBE_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: 'C6c2AisU4ipp3p8vRco3',
          defaultMessage: 'Relaxing',
          description: 'Hotel review describe option label for relaxing in the user reviews section',
        }),
        value: 'relaxing',
      },
      {
        label: intl.formatMessage({
          id: 'qYRxYx-X45nIgVwHU3cL',
          defaultMessage: 'Comfortable',
          description: 'Hotel review describe option label for comfortable',
        }),
        value: 'comfortable',
      },
      {
        label: intl.formatMessage({
          id: 'SlPCO-XI8zC1UVVuHmgT',
          defaultMessage: 'Clean',
          description: 'Hotel review describe option label for clean in the reviews section',
        }),
        value: 'clean',
      },
      {
        label: intl.formatMessage({
          id: 'nja_5SXuOKxUsFk4QnQu',
          defaultMessage: 'Value for money',
          description: 'Hotel review describe option label for value for money',
        }),
        value: 'value_for_money',
      },
      {
        label: intl.formatMessage({
          id: 'L2cqjyd8ZLZTFZ1jNUv8',
          defaultMessage: 'Good facilities',
          description: 'Hotel review describe option label for good facilities',
        }),
        value: 'good_facilities',
      },
      {
        label: intl.formatMessage({
          id: 'uCSEsTy7jNdrm8wMNql3',
          defaultMessage: 'Kid friendly',
          description: 'Hotel review describe option label for kid friendly',
        }),
        value: 'kid_friendly',
      },
    ]

    const EXPERIENCE_DESCRIBE_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: '6ZR3lD2yEt-sl_XIjJVO',
          defaultMessage: 'Relaxing',
          description: 'Experience review describe option label for relaxing',
        }),
        value: 'relaxing',
      },
      {
        label: intl.formatMessage({
          id: 'f6LqnwDWg9--AzAjAahX',
          defaultMessage: 'Comfortable',
          description: 'Experience review describe option label for comfortable',
        }),
        value: 'comfortable',
      },
      {
        label: intl.formatMessage({
          id: '4VhEUTbQlwncZARR01ex',
          defaultMessage: 'Clean',
          description: 'Experience review describe option label for clean in the user reviews section',
        }),
        value: 'clean',
      },
      {
        label: intl.formatMessage({
          id: 'HzDtamoPLUmppTJ9_f9m',
          defaultMessage: 'Variety of meals',
          description: 'Experience review describe option label for variety of meals',
        }),
        value: 'variety_of_meals',
      },
      {
        label: intl.formatMessage({
          id: 'F06CFXivwfLrnL5AdFtz',
          defaultMessage: 'Good value',
          description: 'Experience review describe option label for good value',
        }),
        value: 'good_value',
      },
      {
        label: intl.formatMessage({
          id: 'NAbxuCd_EyP2QFqmdl_G',
          defaultMessage: 'On-time',
          description: 'Experience review describe option label for on-time',
        }),
        value: 'on_time',
      },
    ]

    const TOUR_DESCRIBE_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: 'j1woZfAw_gQ5Qas3WghB',
          defaultMessage: 'Culturally immersive',
          description: 'Tour review describe option label for culturally immersive',
        }),
        value: 'culturally_immersive',
      },
      {
        label: intl.formatMessage({
          id: 'N1EW9pqNq46vC0ybaDwB',
          defaultMessage: 'Comfortable & convenient',
          description: 'Tour review describe option label for comfortable and convenient',
        }),
        value: 'comfortable_convenient',
      },
      {
        label: intl.formatMessage({
          id: '5NI4OJIeYzCcCWBczAjs',
          defaultMessage: 'Engaging itinerary',
          description: 'Tour review describe option label for engaging itinerary',
        }),
        value: 'engaging_itinerary',
      },
      {
        label: intl.formatMessage({
          id: 's8cF3SAmV4_I3dU8rdlf',
          defaultMessage: 'Expert guides',
          description: 'Tour review describe option label for expert guides',
        }),
        value: 'expert_guides',
      },
      {
        label: intl.formatMessage({
          id: 'kEFjQO52Yubk3H21q0-q',
          defaultMessage: 'Flexible options',
          description: 'Tour review describe option label for flexible options',
        }),
        value: 'flexible_options',
      },
      {
        label: intl.formatMessage({
          id: 'LyJbZkvYXH6FbXjXqJYM',
          defaultMessage: 'Hidden gems',
          description: 'Tour review describe option label for hidden gems in the user reviews section',
        }),
        value: 'hidden_gems',
      },
      {
        label: intl.formatMessage({
          id: '3m3b-FnHXFkNW_rfeAAX',
          defaultMessage: 'Iconic landmarks',
          description: 'Tour review describe option label for iconic landmarks',
        }),
        value: 'iconic_landmarks',
      },
      {
        label: intl.formatMessage({
          id: 'icXP99RLRanVoYtNAuKd',
          defaultMessage: 'Good value',
          description: 'Tour review describe option label for good value in the user reviews section',
        }),
        value: 'good_value',
      },
      {
        label: intl.formatMessage({
          id: '2ofII9O3JIITfxxrZMcg',
          defaultMessage: 'Luxurious',
          description: 'Tour review describe option label for luxurious in the user reviews section',
        }),
        value: 'luxurious',
      },
      {
        label: intl.formatMessage({
          id: 'VxUHQeP6hgxfm9MfSXMN',
          defaultMessage: 'Memorable',
          description: 'Tour review describe option label for memorable in the user reviews section',
        }),
        value: 'memorable',
      },
      {
        label: intl.formatMessage({
          id: '_3UbngkK69YfKevJb0gd',
          defaultMessage: 'Scenic beauty',
          description: 'Tour review describe option label for scenic beauty',
        }),
        value: 'scenic',
      },
      {
        label: intl.formatMessage({
          id: 'dLcbdjRMf8yY08jj1C-2',
          defaultMessage: 'Safe & secure',
          description: 'Tour review describe option label for safe and secure',
        }),
        value: 'safe_secure',
      },
    ]

    const COMPANIONSHIP_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: 'rRi6xVjSpI1WcNSXvlzl',
          defaultMessage: 'Just myself',
          description: 'Companionship option label for solo travel in the user reviews section',
        }),
        value: 'alone',
      },
      {
        label: intl.formatMessage({
          id: 'QKAp2IpBCiMLCogZKysQ',
          defaultMessage: 'Partner',
          description: 'Companionship option label for travelling with a partner',
        }),
        value: 'partner',
      },
      {
        label: intl.formatMessage({
          id: 'Ryi2w01Xk5H_625U1wMv',
          defaultMessage: 'Family',
          description: 'Companionship option label for family travel in the user reviews section',
        }),
        value: 'family',
      },
      {
        label: intl.formatMessage({
          id: 'qHUXDj2j81lriaQ-C9uo',
          defaultMessage: 'Friends',
          description: 'Companionship option label for travelling with friends',
        }),
        value: 'friends',
      },
      {
        label: intl.formatMessage({
          id: 'Bt208m8gelZlHSd7Vp6Y',
          defaultMessage: 'Other',
          description: 'Companionship option label for other travel companions',
        }),
        value: 'other',
      },
    ]

    const COMPANIONSHIP_ENUM: Record<string, string> = {
      alone: intl.formatMessage({
        id: 'w44SxB7XLzGn7gs9UFem',
        defaultMessage: 'Just myself',
        description: 'Companionship display label for solo travel on review tiles',
      }),
      partner: intl.formatMessage({
        id: 'pzPa2uUo-7uJ32AoVbyl',
        defaultMessage: 'Partner',
        description: 'Companionship display label for partner travel on review tiles',
      }),
      family: intl.formatMessage({
        id: 'f72hg6PRgfKsGFrrpXDo',
        defaultMessage: 'Family',
        description: 'Companionship display label for family travel on review tiles',
      }),
      friends: intl.formatMessage({
        id: 'V00LbY-3I_KVpIpl-Evv',
        defaultMessage: 'Friends',
        description: 'Companionship display label for friends travel on review tiles',
      }),
      other: intl.formatMessage({
        id: 'A5uyi7t3T2foeKrk_GX9',
        defaultMessage: 'Other',
        description: 'Companionship display label for other travel companions on review tiles',
      }),
    }

    const DEFINITION_ENUM: Record<string, string> = {
      relaxing: intl.formatMessage({
        id: 'ParncI34gQbX-ZZ8UnPI',
        defaultMessage: 'Relaxing',
        description: 'Review definition tag label for relaxing in the reviews section',
      }),
      comfortable: intl.formatMessage({
        id: 'PC7LgsZCmgbFovNHL8kH',
        defaultMessage: 'Comfortable',
        description: 'Review definition tag label for comfortable in the reviews section',
      }),
      clean: intl.formatMessage({
        id: 'FReBOf1oT_O77qMqsTW4',
        defaultMessage: 'Clean',
        description: 'Review definition tag label for clean in the guest reviews section',
      }),
      value_for_money: intl.formatMessage({
        id: 'bKjhaDJ5tsDCg_6fFHrh',
        defaultMessage: 'Value for money',
        description: 'Review definition tag label for value for money in the user reviews section',
      }),
      good_facilities: intl.formatMessage({
        id: 'HuSp5TEwvSPIE7-YgPKB',
        defaultMessage: 'Good facilities',
        description: 'Review definition tag label for good facilities in the user reviews section',
      }),
      kid_friendly: intl.formatMessage({
        id: 'Yle9f-uexyHLoRF3rQpw',
        defaultMessage: 'Kid friendly',
        description: 'Review definition tag label for kid friendly in the reviews section',
      }),
      variety_of_meals: intl.formatMessage({
        id: 'WhCcEbZRzcehniNshVqd',
        defaultMessage: 'Variety of meals',
        description: 'Review definition tag label for variety of meals in the user reviews section',
      }),
      good_value: intl.formatMessage({
        id: '7onm2uBraXBqASILgSUt',
        defaultMessage: 'Good value',
        description: 'Review definition tag label for good value in the reviews section',
      }),
      on_time: intl.formatMessage({
        id: 'OiSckaW6ZS2uYnrjTmKq',
        defaultMessage: 'On-time',
        description: 'Review definition tag label for on-time in the guest reviews section',
      }),
      expert_guides: intl.formatMessage({
        id: '8Jn6eqHMRR7fKETKkEzR',
        defaultMessage: 'Expert guides',
        description: 'Review definition tag label for expert guides in the user reviews section',
      }),
      scenic: intl.formatMessage({
        id: 'Y9VAohmkMIxgKzPfF-Ly',
        defaultMessage: 'Scenic beauty',
        description: 'Review definition tag label for scenic beauty in the user reviews section',
      }),
      immersive: intl.formatMessage({
        id: 'efsOyLKx8Xxsw9E3wQla',
        defaultMessage: 'Immersive',
        description: 'Review definition tag label for immersive in the reviews section',
      }),
      luxurious: intl.formatMessage({
        id: 'wxIaxMmSFadYu9mjQ-At',
        defaultMessage: 'Luxurious',
        description: 'Review definition tag label for luxurious in the reviews section',
      }),
      variety_of_activities: intl.formatMessage({
        id: 'EkReqW8zLcV-uKmNTQRx',
        defaultMessage: 'Variety of activities',
        description: 'Review definition tag label for variety of activities',
      }),
      culturally_immersive: intl.formatMessage({
        id: 'ywW91mzjfYB8SNlm9_bC',
        defaultMessage: 'Culturally immersive',
        description: 'Review definition tag label for culturally immersive',
      }),
      comfortable_convenient: intl.formatMessage({
        id: 'p_-KqL9PLJL3Agn6xPf7',
        defaultMessage: 'Comfortable & convenient',
        description: 'Review definition tag label for comfortable and convenient',
      }),
      engaging_itinerary: intl.formatMessage({
        id: 'LoXFB2o7n2yEpMJlPfwR',
        defaultMessage: 'Engaging itinerary',
        description: 'Review definition tag label for engaging itinerary',
      }),
      flexible_options: intl.formatMessage({
        id: '0k6z7P6F_Cu5PG0gTE0A',
        defaultMessage: 'Flexible options',
        description: 'Review definition tag label for flexible options in the user reviews section',
      }),
      hidden_gems: intl.formatMessage({
        id: 'rIgHEX5fPyYuGQvuhfhp',
        defaultMessage: 'Hidden gems',
        description: 'Review definition tag label for hidden gems in the reviews section',
      }),
      iconic_landmarks: intl.formatMessage({
        id: 'NNWORj-fJlqbu2eeAKGp',
        defaultMessage: 'Iconic landmarks',
        description: 'Review definition tag label for iconic landmarks in the user reviews section',
      }),
      memorable: intl.formatMessage({
        id: 'A_-JfU0AFffwT5gjbGzR',
        defaultMessage: 'Memorable',
        description: 'Review definition tag label for memorable in the reviews section',
      }),
      safe_secure: intl.formatMessage({
        id: 'ixSlO26FyYUBBLYOOpgk',
        defaultMessage: 'Safe & secure',
        description: 'Review definition tag label for safe and secure in the user reviews section',
      }),
    }

    const SORT_OPTION_NEWEST: LabelValueOption = {
      label: intl.formatMessage({
        id: 'PEVEv38cEHP_X7XkfPbo',
        defaultMessage: 'Most recent',
        description: 'Review sort option label for most recent reviews in the user reviews section',
      }),
      value: 'newest',
    }

    const SORT_OPTION_OLDEST: LabelValueOption = {
      label: intl.formatMessage({
        id: '47rR9pdxgKOp2OghIrse',
        defaultMessage: 'Oldest',
        description: 'Review sort option label for oldest reviews in the reviews section',
      }),
      value: 'oldest',
    }

    const SORT_OPTION_BEST_RATING: LabelValueOption = {
      label: intl.formatMessage({
        id: 'sLxLlkNMVzZScR91F57h',
        defaultMessage: 'Highest rating',
        description: 'Review sort option label for highest rated reviews',
      }),
      value: 'best_rating',
    }

    const SORT_OPTION_WORST_RATING: LabelValueOption = {
      label: intl.formatMessage({
        id: 'ZllPY9DeCOBxfGjqStdY',
        defaultMessage: 'Lowest rating',
        description: 'Review sort option label for lowest rated reviews in the user reviews section',
      }),
      value: 'worst_rating',
    }

    const SORT_OPTION_MOST_RELEVANT: LabelValueOption = {
      label: intl.formatMessage({
        id: 'bcWagswgT4stzuw8E59b',
        defaultMessage: 'Most relevant',
        description: 'Review sort option label for most relevant reviews',
      }),
      value: 'most_relevant',
    }

    const userReviewsSortOptions: Array<LabelValueOption> = [
      SORT_OPTION_MOST_RELEVANT,
      SORT_OPTION_NEWEST,
      SORT_OPTION_OLDEST,
      SORT_OPTION_BEST_RATING,
      SORT_OPTION_WORST_RATING,
    ]

    const REVIEW_PANEL_SORT_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: 'kTKMlRlGh0A8I7puWpUu',
          defaultMessage: 'Most recent',
          description: 'Review panel sort option for most recent reviews in the user reviews section',
        }),
        value: 'newest',
      },
      {
        label: intl.formatMessage({
          id: '7vCAWYMnmbpydBd1hpjZ',
          defaultMessage: 'Highest rated',
          description: 'Review panel sort option for highest rated reviews',
        }),
        value: 'best_rating',
      },
      {
        label: intl.formatMessage({
          id: 'wctOZaI9GR5_ooG92Wab',
          defaultMessage: 'Lowest rated',
          description: 'Review panel sort option for lowest rated reviews in the user reviews section',
        }),
        value: 'worst_rating',
      },
      {
        label: intl.formatMessage({
          id: 'huKfCm8v6WpIk9Xo5iUE',
          defaultMessage: 'Recommended',
          description: 'Review panel sort option for recommended reviews in the user reviews section',
        }),
        value: 'recommend',
      },
    ]

    const REVIEW_PANEL_RATING_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: 'Q6iXxLsONcwrBvACHlcl',
          defaultMessage: 'All',
          description: 'Review panel rating filter option for all ratings in the user reviews section',
        }),
        value: '',
      },
      {
        label: intl.formatMessage({
          id: 'TxjymdKJRlSmoOJT9y-s',
          defaultMessage: 'Exceptional (9-10)',
          description: 'Review panel rating filter option for exceptional ratings',
        }),
        value: 'exceptional',
      },
      {
        label: intl.formatMessage({
          id: '7V2jRS9x1xWpm4WG4jAi',
          defaultMessage: 'Good (7-8)',
          description: 'Review panel rating filter option for good ratings',
        }),
        value: 'good',
      },
      {
        label: intl.formatMessage({
          id: 'VTOuKlETAVgMZ3tAnuHF',
          defaultMessage: 'Okay (5-6)',
          description: 'Review panel rating filter option for okay ratings',
        }),
        value: 'okay',
      },
      {
        label: intl.formatMessage({
          id: 'MFG9OLyMbyXM42bgssud',
          defaultMessage: 'Poor (3-4)',
          description: 'Review panel rating filter option for poor ratings',
        }),
        value: 'poor',
      },
      {
        label: intl.formatMessage({
          id: 'jsqGBo_EaOqeYF4A4KfW',
          defaultMessage: 'Terrible (1-2)',
          description: 'Review panel rating filter option for terrible ratings',
        }),
        value: 'very-poor',
      },
    ]

    const REVIEW_PANEL_TRAVELLER_OPTIONS: Array<LabelValueOption> = [
      {
        label: intl.formatMessage({
          id: '_2DuFNIP9t8C1dLnwSQP',
          defaultMessage: 'All',
          description: 'Review panel traveller filter option for all traveller types',
        }),
        value: '',
      },
      {
        label: intl.formatMessage({
          id: 'MeAy7karfeoVbl5p3Kdz',
          defaultMessage: 'Partner',
          description: 'Review panel traveller filter option for partner travel',
        }),
        value: 'partner',
      },
      {
        label: intl.formatMessage({
          id: 'Nz_0QxgieAXs_WkYl3qT',
          defaultMessage: 'Family',
          description: 'Review panel traveller filter option for family travel',
        }),
        value: 'family',
      },
      {
        label: intl.formatMessage({
          id: 'boFxL3Dl0CFSYaZkZMdV',
          defaultMessage: 'Friends',
          description: 'Review panel traveller filter option for friends travel',
        }),
        value: 'friends',
      },
      {
        label: intl.formatMessage({
          id: 'Mqz7mB3ind_MEUl93ysY',
          defaultMessage: 'Just myself',
          description: 'Review panel traveller filter option for solo travel',
        }),
        value: 'alone',
      },
    ]

    return {
      HOTEL_DESCRIBE_OPTIONS,
      EXPERIENCE_DESCRIBE_OPTIONS,
      TOUR_DESCRIBE_OPTIONS,
      COMPANIONSHIP_OPTIONS,
      COMPANIONSHIP_ENUM,
      DEFINITION_ENUM,
      userReviewsSortOptions,
      SORT_OPTION_MOST_RELEVANT,
      REVIEW_PANEL_SORT_OPTIONS,
      REVIEW_PANEL_RATING_OPTIONS,
      REVIEW_PANEL_TRAVELLER_OPTIONS,
    }
  }, [intl])
}

export default useReviewLabels
